import { render, staticRenderFns } from "./DbVirtualScroll.vue?vue&type=template&id=2b1a040e&scoped=true&"
import script from "./DbVirtualScroll.vue?vue&type=script&lang=ts&"
export * from "./DbVirtualScroll.vue?vue&type=script&lang=ts&"
import style0 from "./DbVirtualScroll.vue?vue&type=style&index=0&id=2b1a040e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a040e",
  null
  
)

export default component.exports